<template lang="pug">
	.app-core--popover(v-if="visible")
		.app-core--popover-handler(ref="popoverHandler", :style="{ '--left': `${left}px`, '--top': `${top}px` }")
			.popover(ref="popover")
				slot
</template>

<script>
	import VueTypes from 'vue-types';

	export default {
		name: 'app-core--popup',
		components: {
		},
		props: {
			visible: VueTypes.bool.def(true),
			closeOnOutsideClick: VueTypes.bool.def(true)
		},
		data() {
			return {
				left: 0,
				top: 0
			};
		},
		watch: {
			
		},
		created() {
			if (__DEBUG__)
				window.popover = this;
			this.initHandlers();
		},
		destroyed() {
			document.body.removeEventListener('mouseup', this.mouseUp);
			this.$popoverHandler?.parentElement?.removeChild(this.$popoverHandler);
		},
		mounted() {
			this.calcPosition();
		},
		methods: {
			initHandlers() {
				document.body.addEventListener('mouseup', this.mouseUp);
			},
			mouseUp(e) {				
				if (this.closeOnOutsideClick) {
					var clientRect = this.$popoverHandler.getBoundingClientRect();
					var ltPoint = [clientRect.left, clientRect.top];
					var rbPoint = [clientRect.left + clientRect.width, clientRect.top + clientRect.height];

					let isOutside = !(e.clientX >= ltPoint[0] && e.clientX <= rbPoint[0] && e.clientY >= ltPoint[1] && e.clientY <= rbPoint[1]);

					if (__DEBUG__)
						console.debug('Mouse up', { e, isOutside, ltPoint, rbPoint });

					if (isOutside)
						this.$emit('hide');
				}
			},
			calcPosition() {
				const rect = this.$el.parentElement?.getBoundingClientRect();
				this.left = rect.left;
				this.top = rect.top;
				this.$popoverHandler = this.$refs.popoverHandler;
				this.$el.removeChild(this.$popoverHandler);
				document.body.appendChild(this.$popoverHandler);
			}
		}
	};
</script>
<style lang='scss'>
	.app-core--popover-handler {
		/*position: fixed;

		> .popover {*/
			position: absolute;
			top: var(--top);
			left: calc(var(--left) + 20px);
			padding: 20px;
			transform: translate(0%, -50%);
			background: #fff;
			border-radius: 4px;
			box-shadow: 0 11px 15px -7px rgb(0 0 0 / 20%), 0 24px 38px 3px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
		/*}*/
	}
</style>
